var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3793 10.8333C11.9127 9.4625 10.6002 8.5 9.0835 8.5C7.1585 8.5 5.5835 10.075 5.5835 12C5.5835 13.925 7.1585 15.5 9.0835 15.5C10.6002 15.5 11.8835 14.5375 12.3793 13.1667H14.9168V15.5H17.2502V13.1667H18.4168V10.8333H12.3793ZM9.0835 13.1667C8.44183 13.1667 7.91683 12.6417 7.91683 12C7.91683 11.3583 8.44183 10.8333 9.0835 10.8333C9.72516 10.8333 10.2502 11.3583 10.2502 12C10.2502 12.6417 9.72516 13.1667 9.0835 13.1667Z",
    fill: "#FF69B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.aae2a90ebad8f34e733d1f247e3e6bf6.svg";
export { ForwardRef as ReactComponent };